








import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { IDateInputBehavior } from "../../../../../documaker/domain/format/objects";

@Component
export default class DateInputBehaviorEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: IDateInputBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IDateInputBehavior) => T, defaultValue: T) => T;

  get isFuzzyInputtable(): boolean {
    return this.readPropertyOrDefault(s => s.isFuzzyInputtable, true);
  }

  set isFuzzyInputtable(value: boolean) {
    this.writePropertyWhenValid(s => s.isFuzzyInputtable = value);
  }
}
